(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver, petalObserver, resizeObserver;
  let paused = false;
  const NS = 'http://www.w3.org/2000/svg';
  const petalShape = 'M19 2C28 3 35 12 33 23C31 36 21 47 8 53C11 44 6 39 5 31C3 18 11 7 19 2Z';
  function initPetals(root) {
    if ('IntersectionObserver' in window) petalObserver ||= new IntersectionObserver(entries => entries.forEach(entry => {
      entry.target.classList.toggle('ix-petals-live', entry.isIntersecting);
    }), {rootMargin:'80px'});
    if ('ResizeObserver' in window) resizeObserver ||= new ResizeObserver(entries => entries.forEach(entry => {
      entry.target.style.setProperty('--travel', (entry.contentRect.height + 190) + 'px');
    }));
    root.querySelectorAll('[data-ix-petals]:not([data-ix-petals-ready])').forEach(layer => {
      layer.dataset.ixPetalsReady = 'true';
      const dark = layer.dataset.ixPetals === 'dark';
      const count = window.innerWidth < 750 ? 9 : 14;
      layer.style.setProperty('--travel', (layer.offsetHeight + 190) + 'px');
      for (let i = 0; i < count; i++) {
        const petal = document.createElement('span');
        petal.className = 'ix-petal';
        const variables = {
          '--left':((i * 37 + 7) % 100) + '%',
          '--size':(18 + (i * 7) % 19) + 'px',
          '--opacity':String(dark ? .38 + (i % 4) * .09 : .32 + (i % 4) * .10),
          '--duration':(16 + (i * 3) % 12) + 's',
          '--delay':(-1 - (i * 5.7) % 27) + 's',
          '--rotation':((i * 53) % 360) + 'deg',
          '--sway':(32 + (i * 23) % 80) + 'px',
          '--static-top':((i * 29 + 9) % 90) + '%'
        };
        Object.entries(variables).forEach(([key,value]) => petal.style.setProperty(key,value));
        const svg = document.createElementNS(NS,'svg');
        svg.setAttribute('viewBox','0 0 40 56');
        const path = document.createElementNS(NS,'path');
        path.setAttribute('d',petalShape);
        path.setAttribute('fill',dark ? ['#eab0c0','#f2ced8','#d7819c'][i % 3] : ['#cc708f','#d78ba2','#b64e74'][i % 3]);
        const vein = document.createElementNS(NS,'path');
        vein.setAttribute('d','M21 10C15 25 14 36 9 48');
        vein.setAttribute('stroke',dark ? '#ffedf2' : '#f6dce4');
        vein.setAttribute('stroke-width','.6');
        vein.setAttribute('fill','none');
        vein.setAttribute('opacity','.45');
        svg.append(path,vein); petal.append(svg); layer.append(petal);
      }
      if (petalObserver) petalObserver.observe(layer); else layer.classList.add('ix-petals-live');
      resizeObserver?.observe(layer);
    });
  }
  function showGalleryView(gallery, target) {
    const buttons = [...gallery.querySelectorAll('[data-ix-view]')].filter(button => !button.hidden);
    const chosen = buttons.find(button => button.dataset.ixView === String(target)) || buttons[0];
    if (!chosen) return;
    gallery.querySelectorAll('[data-ix-panel]').forEach(panel => {
      const active = panel.dataset.ixPanel === chosen.dataset.ixView;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    gallery.querySelectorAll('[data-ix-view]').forEach(button => button.setAttribute('aria-pressed', String(button === chosen)));
    const count = gallery.querySelector('[data-ix-gallery-count]');
    if (count) count.textContent = (buttons.indexOf(chosen) + 1) + ' / ' + buttons.length;
    gallery.dispatchEvent(new CustomEvent('ix:gallery-change', {bubbles:true}));
  }
  function setGalleryColor(gallery, color) {
    const buttons = [...gallery.querySelectorAll('[data-ix-view]')];
    const normalized = String(color || '').trim().toLowerCase();
    const colorButtons = buttons.filter(button => button.dataset.ixColor.toLowerCase() === normalized && button.dataset.ixKind !== 'lifestyle');
    if (!colorButtons.length) return;
    const matching = buttons.filter(button => colorButtons.includes(button) || button.dataset.ixKind === 'lifestyle');
    if (!matching.length || (gallery.dataset.ixColorReady && gallery.dataset.ixColor.toLowerCase() === normalized)) return;
    gallery.dataset.ixColor = matching[0].dataset.ixColor;
    gallery.dataset.ixColorReady = 'true';
    buttons.forEach(button => button.hidden = !matching.includes(button));
    showGalleryView(gallery, matching[0].dataset.ixView);
  }
  function initGalleries(root) {
    root.querySelectorAll('[data-ix-color-gallery]:not([data-ix-gallery-ready]),[data-ix-set-gallery]:not([data-ix-gallery-ready])').forEach(gallery => {
      gallery.dataset.ixGalleryReady = 'true';
      if (gallery.hasAttribute('data-ix-set-gallery')) {
        const section = gallery.closest('.shopify-section');
        setGalleryOutfit(gallery, section?.querySelector('input[name="ix-color"]:checked')?.value || gallery.dataset.ixColor, section?.querySelector('input[name="ix-fit"]:checked')?.value || gallery.dataset.ixFit);
      } else setGalleryColor(gallery, gallery.dataset.ixColor);
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || !event.target.closest('[data-ix-view]')) return;
        const buttons = [...gallery.querySelectorAll('[data-ix-view]')].filter(button => !button.hidden);
        const index = buttons.indexOf(event.target.closest('[data-ix-view]'));
        const next = buttons[(index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
        if (!next) return;
        event.preventDefault();
        showGalleryView(gallery, next.dataset.ixView);
        next.focus();
      });
    });
  }
  document.addEventListener('ix:gallery-color', event => {
    const gallery = event.target.closest('[data-ix-color-gallery]');
    if (gallery) setGalleryColor(gallery, event.detail.color);
  });
  function setGalleryOutfit(gallery, color, fit) {
    const teePieces = [...gallery.querySelectorAll('[data-ix-set-color]')];
    const pantsPieces = [...gallery.querySelectorAll('[data-ix-set-fit]')];
    const selectedColor = teePieces.find(piece => piece.dataset.ixSetColor === color)?.dataset.ixSetColor;
    const selectedFit = pantsPieces.find(piece => piece.dataset.ixSetFit === fit)?.dataset.ixSetFit;
    if (!selectedColor || !selectedFit) return;
    if (gallery.dataset.ixSetSelectionReady && gallery.dataset.ixColor === selectedColor && gallery.dataset.ixFit === selectedFit) return;
    gallery.dataset.ixColor = selectedColor;
    gallery.dataset.ixFit = selectedFit;
    gallery.dataset.ixSetSelectionReady = 'true';
    teePieces.forEach(piece => piece.hidden = piece.dataset.ixSetColor !== selectedColor);
    pantsPieces.forEach(piece => piece.hidden = piece.dataset.ixSetFit !== selectedFit);
    gallery.querySelectorAll('[data-ix-set-caption]').forEach(caption => caption.textContent = `${selectedColor} tee / ${selectedFit} pants / ${caption.dataset.ixSetSide}`);
    showGalleryView(gallery, 0);
  }
  document.addEventListener('ix:gallery-set', event => {
    const gallery = event.target.closest('[data-ix-set-gallery]');
    if (gallery) setGalleryOutfit(gallery, event.detail.color, event.detail.fit);
  });
  function init(root = document) {
    initPetals(root);
    initGalleries(root);
    if (!reduced.matches && 'IntersectionObserver' in window) {
      revealObserver ||= new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('ix-visible'); revealObserver.unobserve(entry.target); }
      }), { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
      root.querySelectorAll('[data-ix-reveal]:not([data-ix-ready])').forEach(el => {
        el.dataset.ixReady = 'true';
        if (el.getBoundingClientRect().top > window.innerHeight - 30) el.classList.add('ix-will-reveal');
        revealObserver.observe(el);
      });
    }
    document.body.classList.toggle('ix-motion-paused', paused);
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-ix-motion-toggle]');
    if (toggle) {
      paused = !paused;
      document.body.classList.toggle('ix-motion-paused', paused);
      document.querySelectorAll('[data-ix-motion-toggle]').forEach(button => {
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Play petal animation' : 'Pause petal animation');
        button.querySelector('span').textContent = paused ? 'Play petals' : 'Pause petals';
      });
      return;
    }
    const button = event.target.closest('[data-ix-view]');
    if (!button) return;
    const gallery = button.closest('[data-ix-gallery]');
    if (gallery && !button.hidden) showGalleryView(gallery, button.dataset.ixView);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ix-petals]').forEach(layer => {
    petalObserver?.unobserve(layer); resizeObserver?.unobserve(layer);
  }));
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.ix-will-reveal').forEach(el => el.classList.add('ix-visible'));
  });
})();

(() => {
  document.addEventListener('click',event => {
    const guide = event.target.closest('[data-ix-guide]');
    const trigger = event.target.closest('[data-ix-dialog]');
    const close = event.target.closest('[data-ix-close]');
    if(close) { close.closest('dialog')?.close(); return; }
    if(guide) {
      const dialog = document.getElementById('ix-size-guide');
      if(!dialog) return;
      const form = guide.closest('form');
      const fit = form?.querySelector('input[data-option-name="Fit"]:checked')?.value || 'Loose';
      const kind = guide.dataset.ixGuide;
      dialog.querySelectorAll('[data-ix-guide-copy]').forEach(copy => {
        const name = copy.dataset.ixGuideCopy;
        copy.hidden = !(kind === 'all' || (kind === 'tee' && name === 'tee') || (kind === 'pants' && name === fit) || (kind === 'set' && (name === 'tee' || name === fit)));
      });
      dialog.showModal();
    } else if(trigger) document.getElementById(trigger.dataset.ixDialog)?.showModal();
  });
  function initMontage(root = document) {
    root.querySelectorAll('[data-ix-montage]:not([data-ready])').forEach(wrapper => {
      wrapper.dataset.ready = 'true';
      const video = wrapper.querySelector('video');
      const toggle = wrapper.closest('.ix-hero').querySelector('[data-ix-video-toggle]');
      if(!video || !toggle) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      video.muted = true; video.playsInline = true;
      const update = () => { wrapper.classList.toggle('is-playing',video.readyState >= 2); toggle.textContent = video.paused ? 'Play video' : 'Pause video'; toggle.setAttribute('aria-label',video.paused ? 'Play campaign video' : 'Pause campaign video'); };
      video.addEventListener('play',update); video.addEventListener('pause',update);
      toggle.addEventListener('click',() => video.paused ? video.play().catch(update) : video.pause());
      reduced.addEventListener('change',() => { if(reduced.matches) video.pause(); });
      document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();});
      if(!reduced.matches) video.play().catch(update);
      update();
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initMontage()); else initMontage();
  document.addEventListener('shopify:section:load',event=>initMontage(event.target));
})();
